import { createSelector } from '@reduxjs/toolkit';
import { HTTP_STATUS } from '../../../state/api/services/utils/constants';
import { getBattlesAndMissions } from '../../../state/query/unifiedQuerys/battlesMissions';
import { ASSET_KEY, assetSource } from '../../../utils/assetSource';
import { FE_MISSIONS, FE_MISSIONS_ICON_ANIMATION } from '../../../utils/featureFlags/constants';
import { hasObjectValues } from '../../../utils/object';
import { MISSIONS_GAMEPLAY_STATUS } from '../constants';
import { activateBottomBarAnimation, hasUnderMaintenanceState } from '../utils/missionsPerformance';
export var selectMissionsState = function selectMissionsState(state) {
  return getBattlesAndMissions.select()(state);
};
export var selectMissionsAssets = function selectMissionsAssets(state) {
  return state.assetsPackage.assets.MISSIONS_FEATURE;
};
export var selectActiveTutorial = function selectActiveTutorial(state) {
  return state.tutorial.activeTutorial;
};
export var selectTutorialStep = function selectTutorialStep(state) {
  return state.tutorial.tutorialStep;
};
export var selectCurrentMission = function selectCurrentMission(state) {
  var _state$missions;
  return (_state$missions = state.missions) === null || _state$missions === void 0 ? void 0 : _state$missions.currentMission;
};
var isValidMissionsGameplayStatus = function isValidMissionsGameplayStatus(status) {
  return ![MISSIONS_GAMEPLAY_STATUS.PENDING, MISSIONS_GAMEPLAY_STATUS.CANCELED].includes(status);
};
export var selectShowMissionsButton = createSelector([selectMissionsState, selectMissionsAssets, function (_, hasFeature) {
  return hasFeature(FE_MISSIONS);
}], function (missionsState, assets, hasMissions) {
  var _missionsState$error, _missionsState$data;
  return hasMissions && (missionsState === null || missionsState === void 0 || (_missionsState$error = missionsState.error) === null || _missionsState$error === void 0 ? void 0 : _missionsState$error.status) !== HTTP_STATUS.NOT_FOUND && isValidMissionsGameplayStatus(missionsState === null || missionsState === void 0 || (_missionsState$data = missionsState.data) === null || _missionsState$data === void 0 || (_missionsState$data = _missionsState$data.missionsFeature) === null || _missionsState$data === void 0 ? void 0 : _missionsState$data.missionsGameplayStatus) && hasObjectValues(assets);
});
export var selectRunMissionsAnimation = createSelector([selectMissionsState, selectMissionsAssets, function (_, hasFeature) {
  return hasFeature(FE_MISSIONS_ICON_ANIMATION);
}, selectActiveTutorial], function (missionsState, assets, hasIcon, activeTutorial) {
  var _missionsState$data2;
  return hasIcon && activateBottomBarAnimation(missionsState === null || missionsState === void 0 || (_missionsState$data2 = missionsState.data) === null || _missionsState$data2 === void 0 ? void 0 : _missionsState$data2.missions) && !activeTutorial && hasObjectValues(assets) && !hasUnderMaintenanceState(missionsState);
});
export var selectMissionsIcon = createSelector([selectMissionsState], function (missionsState) {
  return hasUnderMaintenanceState(missionsState) ? assetSource(ASSET_KEY.BOTTOM_BAR_MISSIONS_MAINTENANCE) : assetSource(ASSET_KEY.MISSIONS);
});
export var selectCurrentMissionType = createSelector([selectCurrentMission], function (mission) {
  return mission === null || mission === void 0 ? void 0 : mission.missionType;
});
export var makeMissionsDataSelector = function makeMissionsDataSelector(hasFeature) {
  return createSelector([function (state) {
    return selectShowMissionsButton(state, hasFeature);
  }, function (state) {
    return selectRunMissionsAnimation(state, hasFeature);
  }, selectMissionsIcon, selectMissionsAssets, selectMissionsState], function (showMissionsButton, shouldRunMissionsAnimation, missionsIcon, missionsAssets, missionsState) {
    return {
      showMissionsButton: showMissionsButton,
      shouldRunMissionsAnimation: shouldRunMissionsAnimation,
      missionsIcon: missionsIcon,
      missionsAssets: missionsAssets,
      missionsState: missionsState
    };
  });
};
export var makeTutorialDataSelector = createSelector([selectActiveTutorial, selectTutorialStep, selectCurrentMission], function (activeTutorial, tutorialStep, currentMission) {
  return {
    activeTutorial: activeTutorial,
    tutorialStep: tutorialStep,
    currentMission: currentMission
  };
});